import React from "react";
import { styleLevel } from "../helpers/levelStyle";


export default function Card({ card, handleChoice, flipped, disabled, level }) {

  function handleClick() {
    if (!disabled) {
      handleChoice(card)
    }
  }

  return (
    <div className="card-memory" >
      <div className={flipped ? 'flipped' : ''}>
        <img className="front" src={card.img} style={styleLevel[level].img} alt='card front' />
        <img
          className='back'
          style={styleLevel[level].back}
          onClick={handleClick}
          src={require('../assets/images/background.jpg')}
          alt='card-memory back'
        />
      </div>
    </div>
  );
}